export default __webpack_public_path__ + "static/media/brand-logo-l5-5 1.f2c31b8c.svg";